// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorPage_wrapper__0JYP9","box":"ErrorPage_box__Oc-G5"};